module.exports = __webpack_public_path__ + "img/mobile scanner stand40.b6a31cc3.jpg";